'use strict';

var d3 = require('d3');
var SimpleBarsOverlays = function SimpleBarsOverlays(svgPatternService) {
  /**
   * Draws an overlay over a transparent bar.
   * @param yPropertyName - a property name used to find Y value
   * @returns {Function}
   * @constructor
   */
  return function (yPropertyName) {
    var params, scales;
    var bars = function bars(container) {
      var barWidth = scales.xScale.rangeBand();
      var isViewportChart = container.select('.viewport-groups').size() === 1;
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        if (d[yPropertyName] !== undefined) {
          if (d.overlay || d.overlayViewport) {
            var patternId = isViewportChart ? d.overlayViewport : d.overlay;
            var simpleBars = d3.select(this).selectAll('.simple-bar-overlay').data([d]);
            simpleBars.enter().append('rect').attr('class', 'simple-bar-overlay ' + d.overlay);
            simpleBars.attr({
              'y': function y(d) {
                return scales.yScale(Math.max(d[yPropertyName], 0));
              },
              'width': barWidth,
              'height': function height(d) {
                return Math.abs(scales.yScale(0) - scales.yScale(d[yPropertyName]));
              }
            }).style({
              'fill': function fill() {
                return svgPatternService.getPatternUrl(patternId);
              }
            });
          } else {
            d3.select(this).selectAll('.simple-bar-overlay').remove();
          }
        }
      });
    };
    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    return bars;
  };
};
SimpleBarsOverlays.$inject = ['SvgPatternService'];
module.exports = SimpleBarsOverlays;